<template>
    <section>
        <modal  v-if="showModalRelateLocation" @close="showModalRelateLocation = false"
                v-on:keydown.esc="showModal = false"
                title="Relacionar Localidad"
                :sizeOfModal="'large'"
                :allowScrolling="true"
                :showElement="showModalRelateLocation">
            <template v-slot:modalContent>
                <sui-table celled>
                    <sui-table-header>
                        <sui-table-row>
                            <sui-table-header-cell>Código Postal: {{ location.location.cp }}</sui-table-header-cell>
                            <sui-table-header-cell>Localidad: {{ location.location.colony }}</sui-table-header-cell>
                            <sui-table-header-cell>Tipo: {{ location.location.colony_type }} </sui-table-header-cell>
                        </sui-table-row>
                    </sui-table-header>
                </sui-table>
                <div style="max-height: 600px;">
                    <sui-form @submit.prevent="">
                        Localidades SEPOMEX
                        <sui-table fixed compact="very">
                            <sui-table-header>
                                <sui-table-row>
                                    <sui-table-header-cell class="txtc">Localidad</sui-table-header-cell>
                                    <sui-table-header-cell class="txtc">Tipo</sui-table-header-cell>
                                    <sui-table-header-cell class="txtc">Municipio</sui-table-header-cell>
                                    <sui-table-header-cell class="txtc" ></sui-table-header-cell>
                                </sui-table-row>
                            </sui-table-header>
                            <sui-table-body style="height:80%;overflow-y: scroll;">
                                <sui-table-row v-for="locationSepomex of locationsSepomex" :key="locationSepomex.colony_name">
                                    <sui-table-cell class="txtc">{{ locationSepomex.colony_name }}</sui-table-cell>
                                    <sui-table-cell class="txtc">{{ locationSepomex.colony_type }}</sui-table-cell>
                                    <sui-table-cell class="txtc">{{ locationSepomex.municipality_name }}</sui-table-cell>
                                    <sui-table-cell class="txtc">
                                        <sui-button class="ui left floated button" @click="relateLocation(location.location.colony_id, locationSepomex)" size="mini" color="blue">Relacionar</sui-button>
                                    </sui-table-cell>
                                </sui-table-row>
                            </sui-table-body>
                        </sui-table>
                    </sui-form>
                </div>
            </template>
            <template v-slot:modalFooter>
                <div class="actions">
                    <sui-button negative @click="close(true)">Cancelar</sui-button>
                </div>
            </template>
        </modal>
    </section>
</template>
<script>

import Modal from '@/components/Helpers/Modal.vue'
import Utils from '@/common/Utils.js'
import LocationsService from '@/services/LocationsService'

export default {
    name: 'RelateInegiCode',
    components: { Modal },
    props: {
        showModalRelateLocation: {
            type: Boolean, default: () => false
        },
        location: {
            type: Object, default: () => {}
        }
    },
    data () {
        return {
            Utils: Utils,
            record: {
                colony: '',
                colony_type: ''
            }
        }
    },
    mounted () {
    },
    methods: {
        close () {
            this.showModalRelateLocation = false
            this.$emit('modalResponse', location)
        },
        async relateLocation (colonyId, location) {
            this.$swal({
                title: '¿Deseas actualizar los datos de la localidad?',
                html: '',
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: 'Si',
                confirmButtonColor: '#2BBA45',
                cancelButtonColor: '#d33',
                cancelButtonText: 'No',
                showCloseButton: false,
                allowOutsideClick: false
            }).then(async (result) => {
                if (result.value === true) {
                    this.loader = this.$loading.show()
                    let response = await LocationsService.relateLocation(colonyId, location)
                    this.loader.hide()
                    if (response.status === 'success') {
                        let updatedRecord = {
                            colonyId: colonyId,
                            colony: location.colony_name,
                            colony_type: location.colony_type,
                            postal_code: location.postal_code
                        }
                        this.showModalRelateLocation = false
                        this.$emit('modalResponse', updatedRecord)
                    }
                }
            })
        }
    },
    computed: {
        locationsSepomex () {
            return this.location.locationSepomex.filter((l) => l.valid === false)
        }
    }
}
</script>
